import React, { useEffect, useState } from 'react';
import { Mic, MicOff, Users } from 'lucide-react';

// نوارِ بازدیدِ مشترک (بالای صحنه): آدم‌های داخلِ خانه (با نشانه‌ی «در حالِ صحبت» و میکروفونِ قطع) و دکمه‌ی
// قطع/وصلِ میکروفونِ خودمان
function LiveHud({ live, selfName }) {
  const [snap, setSnap] = useState(() => live.snapshot());
  useEffect(() => live.subscribe(setSnap), [live]);

  const statusText =
    snap.status === 'connecting'
      ? 'در حالِ اتصال…'
      : snap.status === 'full'
        ? 'ظرفیتِ این بازدید پر است'
        : snap.status === 'error'
          ? 'لینکِ بازدید نامعتبر است'
          : null;

  return (
    <div className="live-hud" onPointerDown={(e) => e.stopPropagation()}>
      <div className="live-hud__people">
        <span className="live-hud__count">
          <Users size={14} strokeWidth={2} />
          {(snap.peers.length + 1).toLocaleString('fa-IR')}
        </span>
        <span className={`live-hud__chip is-self ${snap.speaking && !snap.muted ? 'is-speaking' : ''}`}>
          {snap.muted && <MicOff size={12} strokeWidth={2.2} />}
          {selfName || 'شما'} (شما)
        </span>
        {snap.peers.map((p) => (
          <span key={p.id} className={`live-hud__chip ${p.speaking && !p.muted ? 'is-speaking' : ''}`}>
            {p.muted && <MicOff size={12} strokeWidth={2.2} />}
            {p.name}
          </span>
        ))}
        {statusText && <span className="live-hud__status">{statusText}</span>}
        {snap.status === 'live' && snap.peers.length === 0 && <span className="live-hud__status">منتظرِ بقیه… لینک را بفرستید</span>}
      </div>
      <button
        type="button"
        className={`live-hud__mic ${snap.muted || snap.micState === 'denied' ? 'is-off' : ''}`}
        onClick={() => live.setMuted(!snap.muted)}
        disabled={snap.micState === 'denied'}
        aria-label={snap.muted ? 'وصلِ میکروفون' : 'قطعِ میکروفون'}
      >
        {snap.muted || snap.micState === 'denied' ? <MicOff size={20} strokeWidth={2} /> : <Mic size={20} strokeWidth={2} />}
      </button>
    </div>
  );
}

export default LiveHud;
